import TemplateView from '../../TemplateView'
import $ from 'jquery'
import messageResource from '../../messageResource'
import SimpleTooltip from '../../SimpleTooltip'
import {TableTasksConstants} from '../constants'

// TODO: we should make composition of this and import tasks selector

export default class TaskTableTemplate extends TemplateView {
    constructor($containerEl, {
        billingTypes,
        showBillingTypeColumn = true,
        defaultBillingTypeId,
        canAddTasksToUser,
        weekStartDay,
        scheduleCalculator,
        estEnabled,
        defaultRowsNumber,
        isOpenedFromOpenTasks,
        changesCallback,
        validateCallback,
        scrollableContainer,
        getScrollPositionCallback
    }) {
        super($containerEl);
        this.params = {
            billingTypes,
            showBillingTypeColumn,
            defaultBillingTypeId,
            canAddTasksToUser,
            weekStartDay,
            scheduleCalculator,
            estEnabled,
            defaultRowsNumber,
            isOpenedFromOpenTasks,
            changesCallback,
            validateCallback,
            getScrollPositionCallback,
            scrollableContainer
        };
    }

    templateHtml() {
        return "<div class='taskTable'>" +
               "  <div class='taskTableContainer'>" +
               "    <table>" +
               "      <colgroup class='createTasksTableColgroup'>" +
               "          <col class='nameCell'>" +
               "          <col class='descriptionCell'>" +
               "          <col class='estimateCell'>" +
               "          <col class='deadlineCell'>" +
               "          <col class='billingTypeCell'>" +
               "          <col class='addToTTCell'>" +
               "          <col class='clearLineCell'>" +
               "      </colgroup>" +
               "      <thead class='createTasksTableHead'>" +
               "        <tr>" +
               "          <th class='taskNameCell' colspan='2'>" +
               "              <%-taskName%>" +
               "          </th>" +
               "          <th class='estimateCell'>" +
               "              <%=estimate%>" +
               "              <div class='infoIcon'/>" +
               "          </th>" +
               "          <th class='deadlineCell'>" +
               "            <%=deadline%>" +
               "          </th>" +
               "          <th class='billingTypeCell'>" +
               "             <%=typeOfWork%>" +
               "          </th>" +
               "          <th class='addToTTCell addToTTCellHeader'>" +
               "              <div class='tableHeaderCheckboxContainer'></div>" +
               "              <div class='infoIcon'/>" +
               "          </th>" +
               "          <th class='clearLineCell'>&nbsp;</th>" +
               "      </tr>" +
               "      </thead>" +
               "    </table>" +
               "  </div>" +
               "  <div class='addRowsContainer'>" +
               "    <div class='addRowsButton addRowButton'><%=addNewRow%></div>" +
               "    <div class='addRowsButton addFiveRows'>5 <%=rows%></div>" +
               "    <div class='addRowsButton addTenRows'>10 <%=rows%></div>" +
               "  </div>" +
               "</div>";
    }

    messageKeys() {
        return {
            "taskName": "add_new_tasks.task_name",
            "estimate": "add_new_tasks.columns.estimate",
            "deadline": "add_new_tasks.columns.deadline",
            "typeOfWork": "add_new_tasks.columns.billing_type",
            "addNewRow": "add_new_tasks.add_new_row",
            "rows": "add_new_tasks.rows"
        };
    }

    update() {
    }

    afterRender() {
        this.$taskTable = this.$el.find(".taskTableContainer");
        this.spinner = new Spinner({length: 3, width: 2, radius: 3, lines: 8, color: '#aaaaaa', trail: 60});
        this.importSpinnerPlaceholder = this.$containerEl.find(".importSpinnerPlaceholder");
        this.oldGetOnPageDescription = window.getOnPageDescription;

        this.createCreateTasksTable();
        this.createTooltips();

        this.$addRowButton = this.$el.find(".addRowButton");
        this.$addRowButton.click(() => {
            this.createTasksTable.addEmptyRows(1);
        });

        if (this.params.isOpenedFromOpenTasks) {
            this.$addFiveRowsButton = this.$el.find(".addFiveRows");
            this.$addTenRowsButton = this.$el.find(".addTenRows");
            this.$addFiveRowsButton.click(() => {
                this.createTasksTable.addEmptyRows(5);
            });
            this.$addTenRowsButton.click(() => {
                this.createTasksTable.addEmptyRows(10);
            });
        }
        else {
            this.$el.find(".addRowsContainer").addClass("addOneRowOnly");
        }
    }

    validate() {
        return this.createTasksTable.validate();
    }

    isEmpty() {
        return this.createTasksTable.isEmpty();
    }

    hasErrors() {
        return this.createTasksTable.hasErrors();
    }

    createCreateTasksTable() {
        this.createTasksTable = new CreateNewTasksTable().init(
            this.$taskTable.find(".createTasksTableHead")[0],
            this.$taskTable.find(".createTasksTableColgroup")[0],
            this.params.defaultRowsNumber,
            null,
            this.params.billingTypes,
            this.params.defaultBillingTypeId,
            this.params.showBillingTypeColumn,
            this.params.weekStartDay,
            this.params.scheduleCalculator,
            this.params.canAddTasksToUser && this.params.isOpenedFromOpenTasks,
            this.params.canAddTasksToUser,
            this.params.estEnabled,
            this.params.validateCallback,
            this.params.changesCallback,
            this._self(this.showDescriptionPopup),
            this._self(this.hideDescriptionPopup),
            this.params.scrollableContainer
        );

        this.$taskTable[0].innerHTML = "";
        this.createTasksTable.buildDOM(this.$taskTable[0]);
    }

    createTableTooltip($tooltip, text, $position, extraClass) {
        $tooltip.remove();
        const tooltip = new SimpleTooltip({
            text,
            extraClass,
        }).init($('body'))
        tooltip.subscribeToMouseEvents($position);
    }

    createTooltips() {
        this.createTableTooltip(
            $(".estimateTooltip.taskListPage"),
            messageResource.getMessage("add_new_tasks.estimate_tooltip_info"),
            this.find(".estimateCell .infoIcon"),
            "estimateTooltip taskListPage"
        );

        if (this.params.canAddTasksToUser && this.params.isOpenedFromOpenTasks) {
            this.createTableTooltip(
                $(".addToTimeTrackTooltip.taskListPage"),
                messageResource.getMessage("add_new_tasks.add_task_to_enter_tt_note.me"),
                this.find(".addToTTCell .infoIcon"),
                "addToTimeTrackTooltip taskListPage"
            );
        }
    }

    getTasks() {
        return this.createTasksTable.getTasks();
    }

    getCreateTasksTable() {
        return this.createTasksTable;
    }

    _self(func) {
        var self = this;

        return function() {
            return func.apply(self, arguments);
        }
    }

    showDescriptionPopup(description, descriptionCellId, descriptionTd, descriptionChangedCallback) {
        if (editDescriptionState) {
            if (editDescriptionState.objectId == descriptionCellId || !saveOnPageDescription())
                return;
        }

        var offsetX = -100;
        var offsetY = 25 + this.params.getScrollPositionCallback()

        var self = this;
        $(this.params.scrollableContainer).on('scroll', function(e) {
            self.hideDescriptionPopup(false);
        });

        showSavingDescriptionWithOffset(descriptionCellId, descriptionTd.firstChild,
            new CreateTaskDescriptionUtil(description, descriptionChangedCallback),
            descriptionTd, true, offsetX, offsetY);
    }

    hideDescriptionPopup(isConfirmNeeded) {
        if (isConfirmNeeded) {
            return editDescriptionPopup.hide();
        }
        else {
            saveOnPageDescription(true);
            return true;
        }
    }

    restoreGetOnPageDescriptionFunction() {
        window.getOnPageDescription = this.oldGetOnPageDescription;
    }

    startImportSpin() {
        this.spinner.spin(this.importSpinnerPlaceholder[0]);
    }

    stopImportSpin() {
        this.spinner.stop();
    }

    importTasksRequest(taskIds, needToLoadDescriptions, customerId, projectId, isInActiveProjects) {
        var self = this;
        var requestedTaskCount = taskIds ? taskIds.length : -1;

        var errorHandler = function(jqXHR, textStatus, errorThrown) {
            self.stopImportSpin();
            return false;
        };

        var successHandler = function(tasks) {
            self.createTasksTable.addTasks(tasks.list);
            self.stopImportSpin();
            var retrievedTaskCount = tasks.list.length;
            if (retrievedTaskCount == 0 && requestedTaskCount == -1 || retrievedTaskCount < requestedTaskCount) {
                // TODO: change texts!
                if (retrievedTaskCount == 0)
                    if (!customerId)
                        alert(messageResource.getMessage('add_new_tasks.import.err.all_tasks_deleted_unavailable'));
                    else if (isInActiveProjects)
                        alert(messageResource.getMessage('add_new_tasks.import.err.all_tasks_deleted_unavailable_archived'));
                    else
                        alert(messageResource.getMessage('add_new_tasks.import.err.all_tasks_deleted_unavailable_restored'));
                else
                    alert(messageResource.getMessage('add_new_tasks.import.err.some_tasks_deleted_unavailable'));
            }
        };

        if (requestedTaskCount == -1 || requestedTaskCount > 0) {
            self.startImportSpin();
            makeRpcCall("ImportTasksService.importTasks",
                [taskIds, needToLoadDescriptions, customerId || 0, projectId || 0, isInActiveProjects],
                successHandler,
                errorHandler);
        }
    }


    handleTaskError(taskError, taskErrorRowNumber) {
        var self = this;
        switch (taskError) {
            case TableTasksConstants.OPEN_TASK_EXISTS_ERROR:
                alert(messageResource.getMessage('add_new_tasks.err_duplicate_detected.open_task'));
                self.getCreateTasksTable().showTaskNameExistsError(taskErrorRowNumber, false);
                break;

            case TableTasksConstants.COMPLETED_TASK_EXISTS_ERROR:
                alert(messageResource.getMessage('add_new_tasks.err_duplicate_detected.completed_task'));
                self.getCreateTasksTable().showTaskNameExistsError(taskErrorRowNumber, true);
                break;

            case TableTasksConstants.UNKNOWN_TASK_EXISTS_ERROR:
                alert(messageResource.getMessage("add_new_tasks.js.unexpected_error"));
                break;
        }
    }

    handleBillingTypeError(billingTypeError, billingTypes) {
        var self = this;
        switch (billingTypeError) {
            case TableTasksConstants.BILLING_TYPE_DELETED_OR_ARCHIVED_ERROR:
                alert(messageResource.getMessage("add_new_tasks.billing_types_deleted_or_archived"));
                self.getCreateTasksTable().updateBillingTypes(billingTypes);
                break;
        }
    }
}


// WEBPACK FOOTER //
// ./web/js/taskManagement/createLightbox/TaskTableTemplate.js